type PerfDebugFlag =
  | "enabled"
  | "frameCullLog"
  | "layoutReadProbe"
  | "nativeSurfaceRoles"
  | "phaseLogs"
  | "sharpZoomFrameCounts"
  | "sharpZoomSettle";

const STORAGE_PREFIX = "denker.perf.";

const PERF_DEBUG_KEYS: Record<PerfDebugFlag, string> = {
  enabled: `${STORAGE_PREFIX}enabled`,
  frameCullLog: `${STORAGE_PREFIX}frameCullLog`,
  layoutReadProbe: `${STORAGE_PREFIX}layoutReadProbe`,
  nativeSurfaceRoles: `${STORAGE_PREFIX}nativeSurfaceRoles`,
  phaseLogs: `${STORAGE_PREFIX}phaseLogs`,
  sharpZoomFrameCounts: `${STORAGE_PREFIX}sharpZoomFrameCounts`,
  sharpZoomSettle: `${STORAGE_PREFIX}sharpZoomSettle`,
};

const truthyValues = new Set(["1", "true", "yes", "on"]);

const readRawPerfDebugFlag = (flag: PerfDebugFlag): boolean => {
  if (!import.meta.env.DEV || typeof window === "undefined") return false;
  try {
    const value = window.localStorage.getItem(PERF_DEBUG_KEYS[flag]);
    return value !== null && truthyValues.has(value.trim().toLowerCase());
  } catch {
    return false;
  }
};

export const readPerfDebugFlag = (flag: PerfDebugFlag): boolean => {
  if (flag === "enabled") return readRawPerfDebugFlag("enabled");
  return readRawPerfDebugFlag("enabled") && readRawPerfDebugFlag(flag);
};

export const perfDebugStorageKey = (flag: PerfDebugFlag) =>
  PERF_DEBUG_KEYS[flag];
